import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORIES = [
  "Toutes",
  "Actualites EDUCPEOPLE",
  "Inclusion & Societe",
  "IA & Education",
  "Temoignages",
  "Evenements",
];

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [activeCategory, setActiveCategory] = useState("Toutes");

  useEffect(() => {
    const params = activeCategory !== "Toutes" ? `?category=${encodeURIComponent(activeCategory)}` : "";
    axios.get(`${API}/blog${params}`).then((r) => setPosts(r.data)).catch(() => {});
  }, [activeCategory]);

  return (
    <div data-testid="blog-page" className="pt-24">
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-body text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-blue-400 mb-6">
            Blog & Actualites
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-50 mb-8 leading-[1.1]">
            Nos dernieres publications
          </h1>
          <p className="font-body text-base md:text-lg font-light text-slate-300 max-w-3xl mb-12">
            Retrouvez nos articles, temoignages et analyses sur l'education, l'inclusion numerique et l'intelligence artificielle.
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap gap-3 mb-16" data-testid="blog-category-filter">
            {CATEGORIES.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                data-testid={`blog-filter-${cat.toLowerCase().replace(/\s+/g, '-')}`}
                className={`font-body text-sm px-5 py-2.5 rounded-full transition-all duration-200 ${
                  activeCategory === cat
                    ? "bg-blue-500 text-white font-medium"
                    : "bg-white/5 border border-white/10 text-slate-400 hover:text-slate-50 hover:border-white/30"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {posts.length === 0 ? (
            <p className="font-body text-slate-400 text-center py-12">Aucun article dans cette categorie.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((post) => (
                <Link
                  key={post.slug}
                  to={`/blog/${post.slug}`}
                  data-testid={`blog-item-${post.slug}`}
                  className="group bg-slate-900/50 border border-white/10 rounded-2xl overflow-hidden hover:border-blue-500/30 transition-all duration-300 program-card-hover"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={post.image_url}
                      alt={post.title}
                      className="w-full h-full object-cover img-zoom opacity-70 group-hover:opacity-90 transition-opacity"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="font-body text-xs bg-blue-500/20 text-blue-400 px-3 py-1 rounded-full backdrop-blur-sm">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="font-body text-xs text-slate-500 mb-2">
                      {new Date(post.published_at).toLocaleDateString("fr-FR", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </p>
                    <h3 className="font-heading text-xl font-medium text-slate-50 mb-2 group-hover:text-blue-400 transition-colors">
                      {post.title}
                    </h3>
                    <p className="font-body text-sm text-slate-400 line-clamp-3">
                      {post.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
